// extracted by mini-css-extract-plugin
export var center = "_4s-2";
export var clickableRow = "_4s-5";
export var expandedRow = "_4s-7";
export var hoverable = "_4s-4";
export var left = "_4s-1";
export var right = "_4s-3";
export var row = "_4s-0";
export var selectedRow = "_4s-6";
export var summaryRow = "_4s-8";